var React = require('react');

function UserWifiLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.196 17.143A11 11 0 0121.41 24.44a1 1 0 11-1.892.646A9 9 0 002 27.999V34h4a1 1 0 01.997.917L7.92 46h6.16l.924-11.083A1 1 0 0116.012 34l4 .052a1 1 0 11-.026 2l-3.068-.04-.923 11.071A1 1 0 0115 48H7a1 1 0 01-.997-.917L5.08 36H1a1 1 0 01-1-1v-7a11 11 0 019.196-10.857zM7.939.609a8 8 0 116.122 14.782A8 8 0 017.94.609zM11 2a6 6 0 100 12 6 6 0 000-12zm21.525 40.025a3.5 3.5 0 114.95 4.95 3.5 3.5 0 01-4.95-4.95zM35 43a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM22.371 30.469a20.078 20.078 0 0125.258 0 1 1 0 01-1.258 1.554 18.078 18.078 0 00-22.742 0 1 1 0 11-1.258-1.554zM35 36c-2.32 0-4.568.795-6.371 2.254a1 1 0 11-1.258-1.556 12.132 12.132 0 0115.258 0 1 1 0 11-1.258 1.556A10.132 10.132 0 0035 36z"}));
}

UserWifiLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = UserWifiLight;

UserWifiLight.default = UserWifiLight;
